import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { MDBBtn } from 'mdb-react-ui-kit';

import {
    LoginFormDiv, ResetPasswdInitForm
} from '../components/content/auth-forms.component'
import { LoginPageTemplate } from '../components/content/auth-helpers.component';
import { CommonCard } from '../components/content/mdb-custom.component';


const OldPanelBtnWrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;

    @media(max-width: 800px) {
        display: none;
    }
`

export const LoginPage = () => {
    let location = useLocation();
    const [showReset, setShowReset] = useState(
        location.pathname.includes('passwd_reset_init')
    );

    return (
    <>
        <OldPanelBtnWrapper>
            <MDBBtn color='korsecondary' className='fw-normal'
                    href="https://mid.panel.korbank.pl/">
                Stary Panel Klienta
            </MDBBtn>
        </OldPanelBtnWrapper>
        <LoginPageTemplate>
            <CommonCard bg={showReset ? 'danger' : 'korprimary'}
                        cardTitle={`Panel Klienta ${showReset ? ' - Reset Hasła' : ''}`}>
                {showReset ?
                <ResetPasswdInitForm showLogin={() => { setShowReset(false) }} />
                : <LoginFormDiv showReset={() => { setShowReset(true) }} />
                }
            </CommonCard>
        </LoginPageTemplate>
    </>
    )
}
